import type { FaireProductEntity } from "../../entity_types/product";

export const p_wznquh5f6u: FaireProductEntity = {
  token: "p_wznquh5f6u",
  type: "product",
  name: "Seabright House Blend",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/282982d3b7c12a17e59c714fb9e79d716c3d6a2b68dd5a16bc41b6656c7b0c68.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c940a8a74a686d4cdf177008fbdee30751c1d31d80b72117382c16cb8f90bd96.png",
    "https://cdn.faire.com/fastly/0eef6f1f16ebe92635d30230fb73c2d6ea1fd3d7c9d187bd7326069141f26dcc.png"
  ],
  priceDollars: 79,
  description: "From our house to yours, Seabright House Blend is undeniably inviting. Seabright showcases apricot and honeydew flavor notes composed of direct trade coffees from El Salvador and Guatemala. A balanced mouthfeel. And aromatics of toasted hazelnuts. Set yourself up for a winning day with one of our easiest drinking blends.",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:13.080Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
